export const CYCLE_COLORS = [
    { main: "#3CB878", bg: "#F0FBF5" },
    { main: "#007DC1", bg: "#EFF8FD" },
    { main: "#F2994A", bg: "#FFF6ED" },
    { main: "#9B6BDF", bg: "#F7F2FC" },
    { main: "#F45B8D", bg: "#FFF1F5" },
];

export const SCORE_BANDS = [
    { max: 49, bg: "#FBD9CE", text: "#B3401F", label: "0-49%" },
    { max: 69, bg: "#FDEEC7", text: "#8A6D1B", label: "50-69%" },
    { max: 84, bg: "#E4F3D2", text: "#4C7A2A", label: "70-84%" },
    { max: 94, bg: "#C9E8AE", text: "#3D6B23", label: "85-94%" },
    { max: 100, bg: "#8FCB78", text: "#1F4D14", label: "95-100%" },
];

export const getScoreBand = (score) => {
    const band = SCORE_BANDS.find((b) => score <= b.max);
    return band || SCORE_BANDS[SCORE_BANDS.length - 1];
};
